import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ToastType } from "entities/toast-type";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { LoaderService } from "services/loader.service";
import { MyDashboardService } from "services/my-dashboard.service";
import { ToastService } from "services/toast.service";
import * as MyDashboardActions from 'store/my-dashboard/my-dashboard.actions';

@Injectable()
export class MyDashboardEffects {
  unlockQuoteForOthers$ = createEffect(() =>
    this.action$.pipe(
      ofType(MyDashboardActions.unlockQuoteForOthers),
      tap(() => this.loaderService.loading = true),
      switchMap(
        (action) => this.myDashboardService.updateLockStatusForOthers(action.cartId)
          .pipe(
            map(
              () => {
                this.toastService.showToast('This quote is unlocked for others.', ToastType.Success);
                action.onComplete();
                return MyDashboardActions.unlockQuoteForOthersSuccess();
              }
            ),
            catchError(error => of(MyDashboardActions.unlockQuoteForOthersFailed({ error }))),
            tap(() => this.loaderService.loading = false)
          )
      )
    )
  )

  constructor(
    private action$: Actions,
    private toastService: ToastService,
    private myDashboardService: MyDashboardService,
    private loaderService: LoaderService
  ) {}
}
